import Pioneering from "../../images/Pioneering.png"
import { useEffect, useRef, useState } from 'react';
import whoWeAreImage from '../../images/whoWeAreImage.png'
import locationImage from '../../images/Declaration1.png'
import factoryImage from '../../images/Declaration2.png'
import treesImage from '../../images/Declaration3.png'
import sustainableGoals from '../../images/Experiences (1).png'
import waterDrop from '../../images/Experiences (2).png'
import reforestation from '../../images/Experiences (3).png'
import diverseFriends from '../../images/Experiences (4).png'
import researchers from '../../images/Experiences (5).png'
export default function AboutHero() {
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fadeIn');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (textRef.current) observer.observe(textRef.current);
    if (imageRef.current) observer.observe(imageRef.current);

    return () => {
      if (textRef.current) observer.unobserve(textRef.current);
      if (imageRef.current) observer.unobserve(imageRef.current);
    };
  }, []);

  const ImageCard = ({ src, alt, height, caption }) => (
    <div className="relative group rounded-[6px] overflow-hidden shadow-lg">
      <img
        loading="lazy"
        src={src}
        alt={alt}
        className={`w-full object-cover transition-transform duration-500 group-hover:scale-110`}
        style={{ height: `${height}px` }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        {caption && (
          <div className="absolute bottom-0 left-0 right-0 p-4 text-white text-sm font-medium">
            {caption}
          </div>
        )}
      </div>
    </div>
  );


  const [formData, setFormData] = useState({
    email: '',
    message: ''
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!formData.message) {
      newErrors.message = 'Message is required';
    }
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);
    try {
      // Add your API endpoint here
      // const response = await fetch('/api/feedback', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify(formData)
      // });

      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));

      setSubmitStatus('success');
      setFormData({ email: '', message: '' });
      setTimeout(() => setSubmitStatus(null), 3000);
    } catch (error) {
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus(null), 3000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section className="relative w-full bg-white mb-6 lg:mb-20 ">
        {/* Main container with exact positioning from Figma */}
        <div className="relative w-full max-w-[1440px] mx-auto pt-[80px]">

          {/* Content container */}
          <div className="relative px-4 sm:px-6 lg:px-0">

            {/* Text content centered */}
            <div className="flex flex-col items-center gap-6 mb-16 lg:mb-16">
              {/* Main heading */}
              <h1 className="text-[30px] md:text-[42px] lg:text-[64px] font-normal  text-center text-[#141414]  mx-auto">
                Pioneering <span className="text-[#0D924F]">Sustainable Solutions</span> <br /> for a Greener Tomorrow
              </h1>

              {/* Subheading */}
              <p className="md:text-[20px] text-[15px] lg:text-[28px] font-normal leading-[1.5] text-center text-[#3B3B3B]  w-full mx-auto px-4">
                Join us on a journey of environmental stewardship, where CloseCarbon's innovative solutions empower individuals and businesses to transform carbon emissions into positive, lasting impact.
              </p>
            </div>

            {/* Background image container */}
            <div
              className="relative w-full max-w-[1200px] mx-auto rounded-[20px] md:px-6 lg:px-8 overflow-hidden lg:min-h-[300px]"
            >
              <img src={Pioneering}
                className="w-full h-full bg-cover bg-center bg-no-repeat rounded-[20px]"
                loading="lazy"

              >
                {/* Optional overlay or content inside the image */}

              </img>
            </div>

          </div>
        </div>
      </section>

      <section className="w-full bg-white py-8 lg:py-20">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">

          {/* Frame 2147228690 - Main container with flex row */}
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-[72px]">

            {/* Frame 1247 - Text content */}
            <div className="flex flex-col items-start gap-4 w-full lg:w-[564px]">
              {/* Who we are heading */}
              <h2 className=" text-[30px] md:text-[42px] lg:text-[48px] font-medium leading-[1.2] lg:leading-[57px] text-[#141414]">
                Who we are
              </h2>

              {/* Description text */}
              <p className=" md:text-[18px] text-[15px] lg:text-[24px] font-medium leading-[1.5] lg:leading-[36px] text-[#3B3B3B]">
                Closecarbon is a carbon tracking and emissions reduction company dedicated to combating climate change by making carbon emissions reduction accessible, actionable, and rewarding. We are founded on the belief that every entity, regardless of its current emissions status, can play a pivotal role in mitigating the effects of climate change.
              </p>
            </div>

            {/* Image 57 */}
            <div className="w-full lg:w-[564px] rounded-[6px] overflow-hidden">
              <img
                loading="lazy"
                src={whoWeAreImage}
                alt="Engineer analyzing wind turbine with tablet in office"
                className="w-full h-auto object-cover"
                style={{ height: 'auto', maxHeight: '376.6px' }}
              />
            </div>

          </div>

        </div>
      </section>

      <section className="w-full bg-white py-16 lg:py-20">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">

          {/* Main container */}
          <div className="flex flex-col gap-10 lg:gap-[40px]">

            {/* Text content */}
            <div className="flex flex-col items-center gap-6 lg:gap-[40px] w-full">
              <h2 className=" text-[30px] md:text-[42px] lg:text-[48px] font-medium leading-[1.2] lg:leading-[57px] text-center text-[#141414]">
                Purpose Declaration
              </h2>

              <p className=" md:text-[18px] text-[15px] lg:text-[16px] font-medium leading-[1.5] lg:leading-[24px] text-center text-[#3B3B3B] max-w-[1200px] w-full">
                We are on a mission to empower plant owners, manufacturing companies, and businesses of all types to not only track their carbon emissions but also convert those emissions into valuable carbon credits. Our platform is designed for both green companies committed to zero emissions and non-green companies taking essential steps toward infrastructure change.
              </p>
            </div>

            {/* Two column image layout */}
            <div className="flex flex-col lg:flex-row gap-6 lg:gap-[39px] w-full">

              {/* Left column */}
              <div className="w-full lg:w-[580.5px]">
                <ImageCard
                  src={locationImage}
                  alt="Sustainable landscape with location marker"
                  height={390}
                  caption="Global Impact"
                />
              </div>

              {/* Right column */}
              <div className="flex flex-col gap-5 lg:gap-[10px] w-full lg:w-[580.5px]">
                <ImageCard
                  src={factoryImage}
                  alt="Industrial factory with emissions"
                  height={190}
                  caption="Industrial Emissions"
                />

                <ImageCard
                  src={treesImage}
                  alt="Forest and nature conservation"
                  height={190}
                  caption="Nature Conservation"
                />
              </div>

            </div>

          </div>

        </div>
      </section>

      <section className="w-full bg-white py-16 lg:py-20">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">

          {/* Frame 2147228690 - Main container with flex row */}
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-[72px]">

            {/* Frame 1247 - Text content */}
            <div className="flex flex-col items-start gap-4 w-full lg:w-[564px]">
              {/* Who we are heading */}
              <h2 className=" text-[30px] md:text-[42px] lg:text-[48px] font-medium leading-[1.2] lg:leading-[57px] text-[#141414]">
                Our Vision
              </h2>

              {/* Description text */}
              <p className=" md:text-[18px] text-[15px] lg:text-[24px] font-medium leading-[1.5] lg:leading-[36px] text-[#3B3B3B]">
                Closecarbon is a carbon tracking and emissions reduction company dedicated to combating climate change by making carbon emissions reduction accessible, actionable, and rewarding. We are founded on the belief that every entity, regardless of its current emissions status, can play a pivotal role in mitigating the effects of climate change.            </p>
            </div>

            {/* Image 57 */}
            <div className="w-full lg:w-[564px] rounded-[6px] overflow-hidden">
              <img
                src={whoWeAreImage}
                loading="lazy"
                alt="Engineer analyzing wind turbine with tablet in office"
                className="w-full h-auto object-cover"
                style={{ height: 'auto', maxHeight: '376.6px' }}
              />
            </div>

          </div>

        </div>
      </section>


      <section className="w-full bg-white py-16 lg:py-20">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">

          {/* Frame 2147228697 - Main container */}
          <div className="flex flex-col gap-8 lg:gap-[40px]">

            {/* Frame 2147228684 - Text content */}
            <div className="flex flex-col items-center gap-6 lg:gap-[40px] w-full">

              {/* Heading */}
              <h2 className=" text-[30px] md:text-[42px] lg:text-[48px] font-medium leading-[1.2] lg:leading-[57px] text-center text-[#141414]">
                Experiences so Far
              </h2>

              {/* Description container */}
              <div className="flex flex-col items-center gap-4 w-full">
                <p className=" md:text-[18px] text-[15px] lg:text-[16px] font-medium leading-[1.5] lg:leading-[24px] text-center text-[#3B3B3B] max-w-[1200px] w-full">
                  At CloseCarbon, we are more than just a company; we are a collective force committed to catalyzing change and fostering sustainability. Our team comprises dedicated individuals with diverse backgrounds, skills, and a shared passion for making a positive impact on the world. Together, we form the heart and soul of our mission to transform carbon emissions into a brighter, greener future.
                </p>

                {/* Join our Team link */}
                <a
                  href="/careers"
                  className=" text-[16px] font-medium leading-[19px] text-[#0D924F] underline hover:text-[#0a7a40] transition-colors duration-300"
                >
                  Join our Team
                </a>
              </div>

            </div>

            {/* Frame 2147228706 - Three column image layout */}
            <div className="flex flex-col lg:flex-row gap-4 lg:gap-[16px] w-full">

              {/* Column 1 - Two stacked images */}
              <div className="flex flex-col gap-2.5 lg:gap-[10px] w-full lg:w-[389.33px]">
                <div className="w-full rounded-[6px] overflow-hidden shadow-lg">
                  <img
                    loading="lazy"
                    src={sustainableGoals}
                    alt="Sustainable development goals still life"
                    className="w-full h-[213px] object-cover transition-transform duration-500 hover:scale-105"
                  />
                </div>
                <div className="w-full rounded-[6px] overflow-hidden shadow-lg">
                  <img
                    loading="lazy"
                    src={waterDrop}
                    alt="Realistic water drop with ecosystem"
                    className="w-full h-[213px] object-cover transition-transform duration-500 hover:scale-105"
                  />
                </div>
              </div>

              {/* Column 2 - Single tall image */}
              <div className="w-full lg:w-[389.33px] rounded-[6px] overflow-hidden shadow-lg">
                <img
                  loading="lazy"


                  src={reforestation}
                  alt="Reforestation done by voluntary group"
                  className="w-full h-[436px] object-cover transition-transform duration-500 hover:scale-105"
                />
              </div>

              {/* Column 3 - Two stacked images */}
              <div className="flex flex-col gap-2.5 lg:gap-[10px] w-full lg:w-[389.33px]">
                <div className="w-full rounded-[6px] overflow-hidden shadow-lg">
                  <img
                    loading="lazy"
                    src={diverseFriends}
                    alt="Diverse friends holding various icons"
                    className="w-full h-[213px] object-cover transition-transform duration-500 hover:scale-105"
                  />
                </div>
                <div className="w-full rounded-[6px] overflow-hidden shadow-lg">
                  <img
                    loading="lazy"
                    src={researchers}
                    alt="Researchers looking at alternative energy sources"
                    className="w-full h-[213px] object-cover transition-transform duration-500 hover:scale-105"
                  />
                </div>
              </div>

            </div>

          </div>

        </div>
      </section>


      <section className="w-full bg-white py-16 lg:py-20">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">

          {/* Frame 2147228708 - Main container */}
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-[163px]">

            {/* Left side - Text content */}
            <div className="flex flex-col gap-2 lg:gap-[8px] w-full lg:w-[459px]">
              <h3 className=" text-[20px] sm:text-[22px] lg:text-[24px] font-medium leading-[1.5] text-[#141414]">
                We'd love to hear your thoughts or feedback!
              </h3>
              <p className=" text-[14px] sm:text-[15px] lg:text-[16px] font-normal leading-[1.5] text-[#3B3B3B]">
                Feel free to reach out by writing to us.
              </p>
            </div>

            {/* Right side - Form */}
            <form onSubmit={handleSubmit} className="flex flex-col gap-6 lg:gap-[32px] w-full lg:w-[578px]">

              {/* Email Field */}
              <div className="flex flex-col gap-3 lg:gap-[16px] w-full">
                {/* Label with asterisk */}
                <div className="flex items-center gap-1">
                  <label className=" text-[12px] font-medium leading-[14px] text-[#141414]">
                    Email Address
                  </label>
                  <span className="text-red-500 text-[10px]">*</span>
                </div>

                {/* Input field */}
                <div className={`relative ${errors.email ? 'mb-4' : ''}`}>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter email address"
                    className={`w-full px-3 py-3 lg:px-4 lg:py-3 text-[12px] lg:text-[14px] font-normal leading-[1.2] text-[#141414] placeholder:text-[#898989] border rounded-xl focus:outline-none focus:border-[#006633] transition-colors ${errors.email ? 'border-red-500' : 'border-[#898989]'
                      }`}
                    style={{ borderWidth: '0.5px' }}
                  />
                  {errors.email && (
                    <p className="absolute -bottom-5 left-0 text-red-500 text-[10px] mt-1">
                      {errors.email}
                    </p>
                  )}
                </div>
              </div>

              {/* Message Field */}
              <div className="flex flex-col gap-3 lg:gap-[16px] w-full">
                {/* Label with asterisk */}
                <div className="flex items-center gap-1">
                  <label className=" text-[12px] font-medium leading-[14px] text-[#141414]">
                    Message
                  </label>
                  <span className="text-red-500 text-[10px]">*</span>
                </div>

                {/* Textarea field */}
                <div className={`relative ${errors.message ? 'mb-4' : ''}`}>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Type your message here..."
                    rows={6}
                    className={`w-full px-3 py-3 lg:px-4 lg:py-3 text-[12px] lg:text-[14px] font-normal leading-[1.5] text-[#141414] placeholder:text-[#898989] border rounded-xl focus:outline-none focus:border-[#006633] transition-colors resize-vertical ${errors.message ? 'border-red-500' : 'border-[#898989]'
                      }`}
                    style={{ borderWidth: '0.5px', minHeight: '175px' }}
                  />
                  {errors.message && (
                    <p className="absolute -bottom-5 left-0 text-red-500 text-[10px] mt-1">
                      {errors.message}
                    </p>
                  )}
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full bg-[#006633] hover:bg-[#005528] active:bg-[#004420] rounded-xl px-4 py-3 lg:py-4 transition-colors duration-300 flex items-center justify-center gap-2 ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''
                  }`}
                style={{ height: '67px' }}
              >
                {isSubmitting ? (
                  <>
                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span className=" text-[14px] lg:text-[16px] font-medium leading-[19px] text-white">
                      Sending...
                    </span>
                  </>
                ) : (
                  <span className=" text-[14px] lg:text-[16px] font-medium leading-[19px] text-white">
                    Send Message
                  </span>
                )}
              </button>

              {/* Submit Status Messages */}
              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 rounded-lg p-3 text-center">
                  <p className="text-green-600 text-sm font-medium">
                    ✓ Thank you for your feedback! We'll get back to you soon.
                  </p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-center">
                  <p className="text-red-600 text-sm font-medium">
                    ✗ Sorry, something went wrong. Please try again later.
                  </p>
                </div>
              )}

            </form>

          </div>

        </div>
      </section>
    </>

  );
}